export { default as GooglePass } from './google-pass';
